import styled from '@emotion/styled';
import { Icon } from '@mdi/react';
import { BaseButton } from '../../base';

export const Controls = styled.div`
    display: flex;
    flex-direction: row-reverse;
`;

export const UnderButton = styled(BaseButton)`
    height: 32px;
    min-width: auto;

    padding: 0 16px;
    margin-left: 16px;
    border-radius: 12px;
`;

export const SendIcon = styled(Icon)`
    vertical-align: middle;
    margin-right: 6px;
`;
